import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import ActionFormatter from "Components/Table/ActionFormatter/ActionFormatter";
import DialogContent from "@material-ui/core/DialogContent";
import Input from "Components/Input/Input";
import Grid from "@material-ui/core/Grid";
import {
  updateStateProjectUser,
  getAllProjectCustomerList,
} from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import Translator from "Languages/Utility/Translator";
import showNotify from "Helpers/Notify";
import * as R from "ramda";
import MuiButton from "Components/MuiButton/MuiButton";
import {DialogActions} from "@material-ui/core";
import SwapHorizontalCircle from "Assets/svg/icon/swapHorizontalCircle.svg";
import { useTranslation } from 'react-i18next';
import * as Icons from "react-bootstrap-icons";

function RequestChangeStatus({ row }) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const {
    projectsListPagination,
    selectedCustomer,
    projectDataSearch,
  } = useSelector((state) => ({
    projectsListPagination: state.project.projectsListPagination,
    selectedCustomer: state.project.selectedCustomer,
    projectDataSearch: state.project.projectDataSearch,
  }));
  const dispatch = useDispatch();
  const [formValid, setFormValid] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [checkValid, setCheckValid] = useState(false);
  const [controls, setControls] = useSetState({
    projectStatus: {
      type: "radio",
      value: null,
      items: {
        TransferUser: { ...row.TransferUser },
        RequesterUser: { ...row.RequesterUser },
        CancelUser: { ...row.CancelUser },
      },
      labelKey: "NameState",
      valueKey: "Id",
      col: 12,
    },
    description: {
      type: "text",
      value: "",
      col: 12,
      validation: {
        required: true,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };

  const handleDialog = () => setOpenDialog(!openDialog);

  const onFinish = async (e) => {
    e.preventDefault();
    const {projectStatus, description} = controls;
    const request = row.RequesterUser==null ? false:  row.RequesterUser.Id === projectStatus.value.Id
    if (
        !R.isEmpty(formValid) &&
        Object.values(formValid).every((item) => item === true)
    ) {
    try {
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
        IdState: projectStatus.value.Id,
        Describ: description.value,
        IsRequest: request
      };
      await dispatch(updateStateProjectUser(data));
      const paramsList = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdCustomer: selectedCustomer.Id,
        IdProject: 0,
        Name: projectDataSearch?.Name,
        Limit: projectsListPagination.Limit,
        Page: projectsListPagination.Page,
      };
      await dispatch(getAllProjectCustomerList(paramsList));
      handleDialog();
    } catch (e) {
      showNotify({
        text: t('correctFormDataRequired'),
        customClass: "error",
      });
    }
      handleDialog();
    }
    else {
      setCheckValid(true);
    }
  };

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
  };

  const onClear = () => {
    setFormValid({});
    setCheckValid(false);
    setControls({ description: { value: "" } });
    setControls({ projectStatus: { value: null } });
  };

  const onEnter = async () => onClear();

  return (
    <>
      <ActionFormatter
        title={<Translator id="requestChangeStatus" />}
        icon={<Icons.ArrowLeftRight size={17} />}
        className="warning-fill"
        onClick={handleDialog}
        disabled={!row.TransferUser && !row.RequesterUser && !row.CancelUser}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="sm"
      >
        <form onSubmit={onFinish}>
          <div className="dialogHeader">
            <p>
              <Translator id="requestChangeStatus" />
            </p>
          </div>
          <DialogContent>
            <Grid container spacing={3} >
              {Object.keys(controls).map((key, index) => {
                return (
                  <Grid
                    item
                    xs={controls[key].col ? controls[key].col : 6}
                    key={key + index}
                  >
                    {controls[key].type === "text" && (
                      <Input
                        setValue={setValue.bind(this)}
                        name={key}
                        validation={controls[key].validation}
                        label={<Translator id={key} />}
                        checkValid={checkValid}
                        type="text"
                        value={controls[key].value}
                      />
                    )}
                    {controls[key].type === "radio" && (
                      <MuiRadioGroup
                        label={<Translator id={key} />}
                        name={key}
                        value={controls[key].value}
                        items={controls[key].items}
                        labelKey={controls[key].labelKey}
                        valueKey={controls[key].valueKey}
                        onChange={onChangeRadio}
                        className="horizontalRadio"
                      />
                    )}
                  </Grid>
                );
              })}
            </Grid>
          </DialogContent>
          <DialogActions>
            <MuiButton
                color="primary"
                type="submit"
                title={<Translator id="button_save" />}
            />
            <MuiButton
                onClick={handleDialog}
                title={<Translator id="enseraf" />}
            />
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
}

export default RequestChangeStatus;
